<!--  -->
<template>
  <div class="dsawr">
    <div class="djadwedw">
      <div style="margin-bottom:20px" class="search_box">
        <el-input v-model="pageIfon.sale_name" placeholder="请输入销售名称" style="width:200px;margin-right:10px" />
        <el-input v-model="pageIfon.phone_vx_account" placeholder="请输入微信号" style="width:200px;margin-right:10px" />

        <el-button type="primary" icon="el-icon-search" @click="serawed">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="daskdw">重置</el-button>
      </div>
      <div><el-button type="success" icon="el-icon-circle-plus" @click="addawe">新增</el-button></div>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="Id"
        align="center"
      />
      <el-table-column
        prop="sale_name"
        label="销售名称"

        align="center"
      />
      <el-table-column
        prop="phone_vx_account"
        label="销售微信号"

        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="creator"
        label="创建人"
        align="center"
      />
      <el-table-column
        prop="creator"
        label="操作"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="weweimaclick(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="exportlisrwdaw(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="私域"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
    >
      <adddialig ref="lookecahrtimg" @callback="callback" />
    </el-dialog>
    <!-- <el-dialog
      title="生成二维码"
      :visible.sync="dialogVisibler"
      width="30%"
    >
      <generate ref="lookecahrtimgrw" @callback="callback" />
    </el-dialog> -->
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import adddialig from './components/adddialig.vue'
// import generate from './components/generate.vue'
import { salerlistwe, deldaatadad } from '@/api/officialaccount.js'
export default {
  name: 'Privatedomainsales',
  components: {
    PaginationRight,
    adddialig
    // generate
  },
  data() {
    return {
      tableData: [],
      total: null,
      pageIfon: {
        page: 1,
        pageSize: 10,
        phone_vx_account: null,
        sale_name: null
      },
      dialogVisible: false,
      dialogVisibler: false
    }
  },
  created() {
    this.exchangedata()
  },
  mounted() {

  },
  methods: {
    async exchangedata() {
      const data = await salerlistwe(this.pageIfon)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    weweimaclick(item) {
      this.dialogVisible = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.lookecahrtimg.send(2, item)
      })
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.exchangedata()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.exchangedata()
    },
    weweimaclickwew(item) {
      this.dialogVisibler = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.lookecahrtimgrw.sendr(item)
      })
    },
    callback(img) {
      this.dialogVisible = false
      this.exchangedata()
    },
    async exportlisrwdaw(id) {
      console.log('item', id)
      this.$confirm('确定要删除吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        console.log('666')
        deldaatadad({
          id: id
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.exchangedata()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    serawed() {
      this.pageIfon.page = 1
      this.exchangedata()
    },
    daskdw() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.pageIfon.phone_vx_account = null
      this.pageIfon.sale_name = null
      this.exchangedata()
    },
    addawe() {
      this.dialogVisible = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.lookecahrtimg.send(1)
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dsawr{
  padding: 20px;
}
.djadwedw{
  display: flex;
  justify-content: space-between;
}
</style>
